import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'helpers/axios/axios';
import { QuoteData, UseGetQuoteDataType } from './types';
import config from '../../Config';
import { useAuth0 } from '../Auth0/Auth0';

export const useGetQuoteData = (quoteId?: string): UseGetQuoteDataType => {
  const location = useLocation();
  const { search } = location;
  // TODO: this and below jest annotation(istanbul ignore next) need to be removed once we don't need it for testing
  const { email: emailOverride } = qs.parse(search, { ignoreQueryPrefix: true });
  const { isLoading: isAuth0Loading } = useAuth0();

  const searchParams = new URLSearchParams({
    quoteId: quoteId || ''
  });

  const getQuoteUrl = `${config.API_QUOTE_ENDPOINT}?${searchParams.toString()}`;

  const {
    isLoading, isError, data, isSuccess
  } = useQuery(
    ['retrieveQuoteData', quoteId],
    () => axios.get<QuoteData>(getQuoteUrl),
    {
      enabled:
        !isAuth0Loading && (Boolean(quoteId)),
      retry: false,
      staleTime: 1000 * 60 * 5 // 5 minutes
    });

  const quoteData = data?.data || {} as QuoteData;
  /* istanbul ignore next */
  const email = emailOverride ? String(emailOverride) : quoteData.contact?.email;

  return {
    data: {
      ...quoteData,
      contact: {
        ...quoteData.contact,
        email: email
      }
    },
    isLoading,
    isError,
    isSuccess
  };
};
